import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'pcons-dialog',
  templateUrl: './pcons-dialog.component.html',
  styleUrls: ['./pcons-dialog.component.scss']
})
export class PconsDialogComponent implements OnInit {

  callDirectionOptions = [
    {label: '' , key: null},
    {label: 'Incoming' , key: 'IN'},
    {label: 'Outgoing' , key: 'OUT'},
  ];

  constructor(public dialogRef: MatDialogRef<PconsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  advancedConditions: any;
  useGlobalAdvancedCondition;
  formValid = true;

  ngOnInit(): void {
    this.initialiseAdvanceConditions();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    if (this.advancedConditions.isQualityEnabled &&  this.useGlobalAdvancedCondition === 'global') {
      this.data.selectedItem.quality.MOS.isUsed = null;
      this.data.selectedItem.quality.ASR.isUsed = null;
    }

    this.onApply.emit(this.data);
  }


  private initialiseAdvanceConditions(): void {
    this.advancedConditions = this.data.advancedConditions;
    this.useGlobalAdvancedCondition = this.data.selectedItem.quality.MOS.isUsed === null ? 'global' : 'specific';

    if (this.advancedConditions.isQualityEnabled && this.useGlobalAdvancedCondition === 'global') {
      this.data.selectedItem.quality.MOS.isUsed = false;
      this.data.selectedItem.quality.ASR.isUsed = false;
    }
  }

  private generateTopologyGroupsInfo(topologyGroups): string {
    return topologyGroups.map((group) => group.name).join(', ');
  }

  checkFormValid(): void {
    if (this.data.selectedItem.voipPeerId === null) {
      this.formValid = false;
    } else {
      this.formValid = true;
    }
  }
}
